import { Component, HostBinding, Input, type OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import {
  BdcCheckPropertyStatusOperation,
  BdcContentV2Service,
  BdcStatusMeta,
  bdcStatusMeta,
} from '@tokeet-frontend/channel-content'
import { ActionFailed, ConfirmDialogService, Toaster } from '@tokeet-frontend/tv3-platform'
import { switchMap, tap } from 'rxjs/operators'
import { BdcClosePropertyDialogService } from '../bdc-close-property/bdc-close-property-dialog.service'

@Component({
  selector: 'app-bdc-listing-status',
  templateUrl: './bdc-listing-status.component.html',
})
export class BdcListingStatusComponent implements OnInit {
  @Input() propertyId: number

  status: BdcStatusMeta
  constructor(
    private store: Store<any>,
    private toaster: Toaster,
    private confirm: ConfirmDialogService,
    private service: BdcContentV2Service,
    private closePropertyDialog: BdcClosePropertyDialogService
  ) {}

  ngOnInit(): void {
    this.refreshStatus()
  }

  refreshStatus() {
    this.service.getProperty(this.propertyId).subscribe(
      (data) => {
        this.status = bdcStatusMeta.find((s) => s.code === data.status)
      },
      () => {}
    )
  }

  getStatusColor = () => {
    if (this.status.canClose) {
      return 'primary'
    } else if (this.status.canOpen) {
      return 'warning'
    } else {
      return 'secondary'
    }
  }

  onOpen() {
    this.confirm
      .confirm({
        title: $localize`Open the property`,
        body: $localize`Are you sure you want to open this property?`,
      })
      .pipe(
        switchMap(() =>
          this.service.checkPropertyStatus(this.propertyId, { operation: BdcCheckPropertyStatusOperation.OPEN })
        ),
        tap(() => this.refreshStatus())
      )
      .subscribe(
        () => {
          this.toaster.success($localize`Property opened successfully.`)
        },
        (error) => {
          this.store.dispatch(ActionFailed({ error }))
        }
      )
  }

  onClose() {
    this.closePropertyDialog.open(this.propertyId).subscribe(() => {
      this.refreshStatus()
    })
  }
}
